import React from "react";
import { Container } from "react-bootstrap";
import AboutContent from "../../components/AboutContent/AboutContent";
import Footer from "../../components/Footer/Footer";
import { StaticHero } from "../../components/StaticHero";

const AboutPage = () => {
  const heroConf = {
    title: "About Us",
    subtitle:
      "Technowren is a company which provides prototyping, manufacturing, designing and fabrication of a mechanical/ electronics/ embedded system.",
  };
  return (
    <div>
      <StaticHero {...heroConf} />
      <Container>
        <AboutContent />
      </Container>
      <Footer />
    </div>
  );
};

export default AboutPage;
